'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { Reveal } from '@/components/site/reveal'
import { SectionHead } from '@/components/site/section-head'
import { SiteSection } from '@/components/site/section'

export function HomeWhySection() {
  const { t } = useTranslation(['web'])
  return (
    <SiteSection divider trackingKey="why">
      <Reveal>
        <SectionHead
          eyebrow={t('web:homePage.why.eyebrow')}
          titleKey="web:homePage.why.title"
          lead={t('web:homePage.why.lead')}
        />
      </Reveal>
    </SiteSection>
  )
}
